import { Col, Row } from "react-bootstrap";
import { Field, useForm, useFormState } from "react-final-form";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";

const ServicePriceFormStepOne = (props) => {
  const { t } = useTranslation();
  const form = useForm();
  const { values } = useFormState();

  const unitValues = [
    { value: "pcs", name: t("global:servicePrice.pcs") },
    { value: "hour", name: t("global:servicePrice.hour") },
  ];

  useEffect(() => {
    if (values.isStaticRateTransportPrice) {
      form.change("staticRateTransportPrice", 25);
    } else {
      form.change("staticRateTransportPrice", 0);
    }
  }, [values.isStaticRateTransportPrice, form]);

  return (
    <div style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:servicePrice.servicepriceData")} />
      <Row>
        <Col xs={12}>
          <Field
            name="name"
            label={`${t("global:servicePrice.name")}*`}
            component={BMXTextField}
            data-cy="name"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <Field
            name="description"
            label={`${t("global:servicePrice.description")}*`}
            component={BMXTextField}
            data-cy="description"
          />
        </Col>
      </Row>
      <Row>
        <Col xs={7}>
          <Row>
            <Col xs={3}>
              <Field
                name="surveyPrice"
                label={`${t("global:servicePrice.surveyPrice")}`}
                component={BMXTextField}
                type="money"
                decimalScale={2}
                data-cy="surveyPrice"
              />
            </Col>
            <Col xs={3}>
              <Field
                values={unitValues}
                name="surveyValue"
                label={`${t("global:servicePrice.surveyValue")}*`}
                component={BMXSelectField}
                data-cy="surveyValue"
              />
            </Col>
            <Col xs={3}>
              <Field
                name="installationPrice"
                label={`${t("global:servicePrice.installationPrice")}`}
                component={BMXTextField}
                type="money"
                decimalScale={2}
                data-cy="installationPrice"
              />
            </Col>
            <Col xs={3}>
              <Field
                values={unitValues}
                name="installationValue"
                label={`${t("global:servicePrice.installationValue")}*`}
                component={BMXSelectField}
                data-cy="installationValue"
              />
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Field
                name="itServicePrice"
                label={`${t("global:servicePrice.itServicePrice")}`}
                component={BMXTextField}
                type="money"
                decimalScale={2}
                data-cy="itServicePrice"
              />
            </Col>
            <Col xs={3}>
              <Field
                values={unitValues}
                name="itServiceValue"
                label={`${t("global:servicePrice.itServiceValue")}*`}
                component={BMXSelectField}
                data-cy="itServiceValue"
              />
            </Col>
            <Col xs={3}>
              <Field
                name="repairPrice"
                label={`${t("global:servicePrice.repairPrice")}`}
                component={BMXTextField}
                type="money"
                decimalScale={2}
                data-cy="repairPrice"
              />
            </Col>
            <Col xs={3}>
              <Field
                values={unitValues}
                name="repairValue"
                label={`${t("global:servicePrice.repairValue")}*`}
                component={BMXSelectField}
                data-cy="repairValue"
              />
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Field
                name="remotePrice"
                label={`${t("global:servicePrice.remotePrice")}`}
                component={BMXTextField}
                type="money"
                decimalScale={2}
                data-cy="remotePrice"
              />
            </Col>
            <Col xs={3}>
              <Field
                values={unitValues}
                name="remoteValue"
                label={`${t("global:servicePrice.remoteValue")}*`}
                component={BMXSelectField}
                data-cy="remoteValue"
              />
            </Col>

            <Col xs={3}>
              <Field
                name="diagnosticsPrice"
                label={`${t("global:servicePrice.diagnosticsPrice")}`}
                component={BMXTextField}
                type="money"
                decimalScale={2}
                data-cy="diagnosticsPrice"
              />
            </Col>
            <Col xs={3}>
              <Field
                values={unitValues}
                name="diagnosticsValue"
                label={`${t("global:servicePrice.diagnosticsValue")}*`}
                component={BMXSelectField}
                data-cy="diagnosticsValue"
              />
            </Col>
          </Row>
        </Col>

        <Col xs={{ span: 4, offset: 1 }}>
          <Row>
            <Col xs={6}>
              <Field
                name="minRateTransportPrice"
                label={`${t("global:servicePrice.minRateTransportPrice")}`}
                component={BMXTextField}
                type="money"
                decimalScale={2}
                data-cy="minRateTransportPrice"
              />
            </Col>
            <Col xs={6}>
              <Field
                name="rateOneKmTransportPrice"
                label={`${t("global:servicePrice.rateOneKmTransportPrice")}`}
                component={BMXTextField}
                type="money"
                decimalScale={2}
                data-cy="rateOneKmTransportPrice"
              />
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Field
                fieldtype="checkbox"
                component={BMXTextField}
                name="isStaticRateTransportPrice"
                label={`${t("global:servicePrice.isStaticRateTransportPrice")}`}
                type="checkbox"
              />
            </Col>
            <Col xs={6}>
              {values.isStaticRateTransportPrice && (
                <Field
                  name="staticRateTransportPrice"
                  label={`${t("global:servicePrice.staticRateTransportPrice")}`}
                  component={BMXTextField}
                  type="money"
                  decimalScale={2}
                  data-cy="staticRateTransportPrice"
                />
              )}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ServicePriceFormStepOne;
